import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils";
export const BrowserWindow = t0 => {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="h-1.5 flex flex-row items-center gap-0.5 md:h-7 md:gap-1.5"><div className="rounded-full bg-neutral-200 size-[3px] md:size-3" /><div className="rounded-full bg-neutral-200 size-[3px] md:size-3" /><div className="rounded-full bg-neutral-200 size-[3px] md:size-3" /></div>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children) {
    t2 = <div className="px-0.5 pb-0.5 md:px-2 md:pb-2"><div>{t1}<div className="aspect-video bg-white rounded-xs border border-neutral-200 md:rounded-lg overflow-clip">{children}</div></div></div>;
    $[5] = children;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== className || $[8] !== props || $[9] !== t2) {
    t3 = <WindowShadow className={className} {...props}>{t2}</WindowShadow>;
    $[7] = className;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export const WindowShadow = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let innerClassName;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      innerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = innerClassName;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    innerClassName = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("bg-black/5 rounded-md p-1 -mx-1 z-20 relative md:rounded-xl", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== innerClassName) {
    t2 = cn("bg-white rounded-sm md:rounded-lg h-full", innerClassName);
    $[7] = innerClassName;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t3) {
    t4 = <div className={t1} {...props}>{t3}</div>;
    $[12] = props;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};